import { stringify } from 'qs';
import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let PublicSecureAuthorization = {

    searchRole: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/search-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListRoles: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/list-group`,
            method: 'GET',
        }, callback)
    },
    createGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/create-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    editGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/edit-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    deleteGroup: (roleName, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/delete-group/${roleName}`,
            method: 'GET'
        }, callback)
    }
}

export default PublicSecureAuthorization
